(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["derucci-ai-story-scroll"] && !Shopify.designMode) return;
  try {
    
(() => {
  const clamp = (n, min, max) => Math.min(max, Math.max(min, n));
  const smoothstep = t => t * t * (3 - 2 * t);

  class DerucciAIStoryV4 extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.stage = this.querySelector('[data-pin]');
      this.scenes = [...this.querySelectorAll('[data-scene]')];
      this.progressDots = [...this.querySelectorAll('.drstory3__progress span')];
      if (!this.stage || this.scenes.length !== 7) return;

      this._prepareHeadingLines();

      this._ticking = false;
      this._scrollSource = null;
      this._onScroll = () => this._requestRender();
      this._onResize = () => {
        clearTimeout(this._resizeTimer);
        this._resizeTimer = setTimeout(() => {
          this._configureScroller();
          this._measure();
          this._requestRender();
        }, 140);
      };

      this._renderScenePosition(0);
      this._configureScroller();
      this._measure();
      window.addEventListener('resize', this._onResize, { passive: true });

      this._requestRender();
    }

    disconnectedCallback() {
      if (!this._ready) return;
      this._unbindScroller();
      window.removeEventListener('resize', this._onResize);
      this._ready = false;
    }

    _prepareHeadingLines() {
      this.querySelectorAll('[data-heading]').forEach(heading => {
        if (heading.dataset.linesReady === 'true') return;

        const parts = heading.innerHTML
          .split(/<br\s*\/?>/i)
          .map(part => part.trim())
          .filter(Boolean);

        if (!parts.length) return;

        heading.innerHTML = parts
          .map(part => `<span class="drstory3__line">${part}</span>`)
          .join('');

        heading.dataset.linesReady = 'true';
      });
    }

    _findScroller() {
      const wrapper = document.querySelector('.page-wrapper');
      if (wrapper) {
        const s = getComputedStyle(wrapper);
        const scrollable =
          /auto|scroll|overlay/.test(s.overflowY) ||
          /auto|scroll|overlay/.test(s.overflow);

        if (scrollable && wrapper.scrollHeight > wrapper.clientHeight + 2) {
          return wrapper;
        }
      }
      return window;
    }

    _configureScroller() {
      const next = this._findScroller();
      if (next === this._scrollSource) return;

      this._unbindScroller();
      this._scrollSource = next;

      if (next === window) {
        window.addEventListener('scroll', this._onScroll, { passive: true });
      } else {
        next.addEventListener('scroll', this._onScroll, { passive: true });
      }
    }

    _unbindScroller() {
      if (!this._scrollSource) return;

      if (this._scrollSource === window) {
        window.removeEventListener('scroll', this._onScroll);
      } else {
        this._scrollSource.removeEventListener('scroll', this._onScroll);
      }
    }

    _scrollTop() {
      return this._scrollSource === window
        ? window.scrollY
        : this._scrollSource.scrollTop;
    }

    _viewportHeight() {
      return this._scrollSource === window
        ? window.innerHeight
        : this._scrollSource.clientHeight;
    }

    _measure() {
      this._configureScroller();

      const rootRect = this.getBoundingClientRect();
      this._viewport = Math.max(this._viewportHeight(), 1);

      if (this._scrollSource === window) {
        this._startY = window.scrollY + rootRect.top;
      } else {
        const wrapperRect = this._scrollSource.getBoundingClientRect();
        this._startY =
          this._scrollSource.scrollTop +
          (rootRect.top - wrapperRect.top);
      }

      this._distance = Math.max(this.offsetHeight - this._viewport, 1);
    }

    _requestRender() {
      if (this._ticking) return;

      this._ticking = true;
      requestAnimationFrame(() => {
        this._ticking = false;
        this._render();
      });
    }

    _render() {
      const y = this._scrollTop();
      const progress = clamp(
        (y - this._startY) / this._distance,
        0,
        1
      );

      /* Exact same scene-position model as the working reference:
         7 scenes = positions 0 through 6. */
      this._renderScenePosition(progress * 6);
    }

    _alphaFor(scenePosition, index) {
      const d = Math.abs(scenePosition - index);

      /* Exact same alpha window as the working reference file. */
      if (d <= 0.22) return 1;
      if (d >= 0.78) return 0;

      const t = (d - 0.22) / 0.56;
      return 1 - smoothstep(t);
    }

    _renderScenePosition(scenePosition) {
      const reduced =
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const nearest = clamp(Math.round(scenePosition), 0, 6);

      this.scenes.forEach((scene, i) => {
        const a = this._alphaFor(scenePosition, i);

        scene.style.visibility = a > 0.01 ? 'visible' : 'hidden';
        scene.style.opacity = a.toFixed(3);
        scene.style.filter = reduced
          ? 'none'
          : `blur(${((1 - a) * 8).toFixed(2)}px)`;

        const delta = i - scenePosition;
        scene.style.transform = reduced
          ? 'none'
          : `translate3d(0, ${(delta * 8).toFixed(2)}px, 0)`;

        const eyebrow = scene.querySelector('.drstory3__eyebrow');
        const lines = [...scene.querySelectorAll('.drstory3__line')];

        /*
          Keep the scene timing identical to the reference.
          Only the CONTENT inside each active scene gets our familiar
          slow stagger: eyebrow, then line 1, line 2, line 3...
        */
        if (eyebrow) {
          const stagger = clamp(a / 0.88, 0, 1);
          const eased = smoothstep(stagger);
          eyebrow.style.opacity = eased.toFixed(3);
          eyebrow.style.filter = reduced
            ? 'none'
            : `blur(${((1 - eased) * 6).toFixed(2)}px)`;
          eyebrow.style.transform = reduced
            ? 'none'
            : `translate3d(0, ${((1 - eased) * 8).toFixed(2)}px, 0)`;
        }

        lines.forEach((line, idx) => {
          const stagger = clamp((a - idx * 0.055) / 0.88, 0, 1);
          const eased = smoothstep(stagger);

          line.style.opacity = eased.toFixed(3);
          line.style.filter = reduced
            ? 'none'
            : `blur(${((1 - eased) * 10).toFixed(2)}px)`;
          line.style.transform = reduced
            ? 'none'
            : `translate3d(0, ${((1 - eased) * 14).toFixed(2)}px, 0)`;
        });
      });

      if (this.progressDots.length) {
        this.progressDots.forEach((dot, i) => {
          const active = i === nearest;

          dot.style.height = active
            ? (window.innerWidth < 750 ? '17px' : '26px')
            : (window.innerWidth < 750 ? '9px' : '14px');

          dot.style.background = active
            ? 'rgba(245,245,247,.76)'
            : 'rgba(245,245,247,.15)';
        });
      }
    }
  }

  if (!customElements.get('derucci-ai-story-v3')) {
    customElements.define('derucci-ai-story-v3', DerucciAIStoryV4);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["derucci-how-it-works"] && !Shopify.designMode) return;
  try {
    
(() => {
  const clamp = (n, min, max) => Math.min(max, Math.max(min, n));
  const smoothstep = t => t * t * (3 - 2 * t);

  class DerucciHowItWorks extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.stage = this.querySelector('[data-pin]');
      this.scenes = [...this.querySelectorAll('[data-scene]')];
      this.overlays = [...this.querySelectorAll('[data-overlay]')];
      this.progressDots = [...this.querySelectorAll('.dhiw5__progress span')];
      if (!this.stage || this.scenes.length !== 6) return;

      this._ticking = false;
      this._scrollSource = null;
      this._onScroll = () => this._requestRender();
      this._onResize = () => {
        clearTimeout(this._resizeTimer);
        this._resizeTimer = setTimeout(() => {
          this._configureScroller();
          this._measure();
          this._requestRender();
        }, 140);
      };

      this._renderScenePosition(0);
      this._configureScroller();
      this._measure();
      window.addEventListener('resize', this._onResize, { passive: true });

      this.querySelectorAll('img').forEach(img => {
        if (!img.complete) {
          img.addEventListener('load', () => {
            this._measure();
            this._requestRender();
          }, { once: true });
        }
      });

      this._requestRender();
    }

    disconnectedCallback() {
      if (!this._ready) return;
      this._unbindScroller();
      window.removeEventListener('resize', this._onResize);
      this._ready = false;
    }

    _findScroller() {
      const wrapper = document.querySelector('.page-wrapper');
      if (wrapper) {
        const s = getComputedStyle(wrapper);
        const scrollable = /auto|scroll|overlay/.test(s.overflowY) || /auto|scroll|overlay/.test(s.overflow);
        if (scrollable && wrapper.scrollHeight > wrapper.clientHeight + 2) return wrapper;
      }
      return window;
    }

    _configureScroller() {
      const next = this._findScroller();
      if (next === this._scrollSource) return;
      this._unbindScroller();
      this._scrollSource = next;
      if (next === window) window.addEventListener('scroll', this._onScroll, { passive: true });
      else next.addEventListener('scroll', this._onScroll, { passive: true });
    }

    _unbindScroller() {
      if (!this._scrollSource) return;
      if (this._scrollSource === window) window.removeEventListener('scroll', this._onScroll);
      else this._scrollSource.removeEventListener('scroll', this._onScroll);
    }

    _scrollTop() {
      return this._scrollSource === window ? window.scrollY : this._scrollSource.scrollTop;
    }

    _viewportHeight() {
      return this._scrollSource === window ? window.innerHeight : this._scrollSource.clientHeight;
    }

    _measure() {
      this._configureScroller();
      const rootRect = this.getBoundingClientRect();
      this._viewport = Math.max(this._viewportHeight(), 1);
      if (this._scrollSource === window) {
        this._startY = window.scrollY + rootRect.top;
      } else {
        const wrapperRect = this._scrollSource.getBoundingClientRect();
        this._startY = this._scrollSource.scrollTop + (rootRect.top - wrapperRect.top);
      }
      this._distance = Math.max(this.offsetHeight - this._viewport, 1);
    }

    _requestRender() {
      if (this._ticking) return;
      this._ticking = true;
      requestAnimationFrame(() => {
        this._ticking = false;
        this._render();
      });
    }

    _render() {
      const y = this._scrollTop();
      const progress = clamp((y - this._startY) / this._distance, 0, 1);
      this._renderScenePosition(progress * 5);
    }

    _alphaFor(scenePosition, index) {
      const d = Math.abs(scenePosition - index);
      if (d <= 0.22) return 1;
      if (d >= 0.78) return 0;
      const t = (d - 0.22) / 0.56;
      return 1 - smoothstep(t);
    }

    _renderScenePosition(scenePosition) {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const nearest = clamp(Math.round(scenePosition), 0, 5);

      this.scenes.forEach((scene, i) => {
        const a = this._alphaFor(scenePosition, i);
        scene.style.visibility = a > 0.01 ? 'visible' : 'hidden';
        scene.style.opacity = a.toFixed(3);
        scene.style.filter = reduced ? 'none' : `blur(${((1 - a) * 8).toFixed(2)}px)`;
        const delta = i - scenePosition;
        scene.style.transform = reduced ? 'none' : `translate3d(0, ${(delta * 8).toFixed(2)}px, 0)`;
      });

      this.overlays.forEach(overlay => {
        const i = Number(overlay.dataset.overlay);
        const a = this._alphaFor(scenePosition, i);
        overlay.style.visibility = a > 0.01 ? 'visible' : 'hidden';
        overlay.style.opacity = a.toFixed(3);
        overlay.style.filter = reduced ? 'none' : `blur(${((1 - a) * 4.5).toFixed(2)}px)`;

        overlay.querySelectorAll('.dhiw5__sensor').forEach((sensor, idx) => {
          const stagger = clamp((a - idx * 0.04) / 0.84, 0, 1);
          const eased = smoothstep(stagger);
          sensor.style.opacity = eased.toFixed(3);
          sensor.style.transform = `scale(${(0.55 + 0.45 * eased).toFixed(3)})`;
        });

        overlay.querySelectorAll('.dhiw5__callout-rule').forEach((rule, idx) => {
          const stagger = clamp((a - idx * 0.035) / 0.86, 0, 1);
          rule.style.transform = `scaleX(${smoothstep(stagger).toFixed(3)})`;
        });

        overlay.querySelectorAll('[data-callout], [data-region], [data-person], [data-support-readout]').forEach((el, idx) => {
          const stagger = clamp((a - idx * 0.025) / 0.90, 0, 1);
          const eased = smoothstep(stagger);
          el.style.opacity = eased.toFixed(3);
          el.style.transform = `translate3d(0, ${((1 - eased) * 7).toFixed(2)}px, 0)`;
        });

        overlay.querySelectorAll('[data-zone]').forEach((zone, idx) => {
          const stagger = clamp((a - idx * 0.03) / 0.84, 0, 1);
          const eased = smoothstep(stagger);
          zone.style.opacity = eased.toFixed(3);
          zone.style.transform = `translate3d(0, ${((1 - eased) * 10).toFixed(2)}px, 0)`;
        });

        overlay.querySelectorAll('[data-support] i').forEach((pillar, idx) => {
          const stagger = clamp((a - idx * 0.028) / 0.86, 0, 1);
          const eased = smoothstep(stagger);
          pillar.style.transform = `scaleY(${(0.06 + 0.94 * eased).toFixed(3)})`;
          pillar.style.opacity = eased.toFixed(3);
        });

        const divider = overlay.querySelector('[data-dual-divider]');
        if (divider) {
          const eased = smoothstep(a);
          divider.style.transformOrigin = '50% 50%';
          divider.style.transform = `scaleY(${eased.toFixed(3)})`;
        }

        overlay.querySelectorAll('[data-dual-side]').forEach(side => {
          side.style.opacity = smoothstep(a).toFixed(3);
        });
      });

      if (this.progressDots.length) {
        this.progressDots.forEach((dot, i) => {
          const active = i === nearest;
          dot.style.height = active ? (window.innerWidth < 750 ? '17px' : '26px') : (window.innerWidth < 750 ? '9px' : '14px');
          dot.style.background = active ? 'rgba(245,245,247,.76)' : 'rgba(245,245,247,.15)';
        });
      }
    }
  }

  if (!customElements.get('derucci-how-it-works')) customElements.define('derucci-how-it-works', DerucciHowItWorks);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
